import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../logo2.png";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",

    marginTop: 20
  },
  cardRoot: {
    width: "90%",
    margin: "0 auto",
    marginTop: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 700,
    color: "#75070d"
  },
  faq: {
    width: "90%",
    margin: "0 auto",
    marginTop: 20,
    marginBottom: 100
  },
  logo: {
    width: 350,
    height: 350,
    display: "inline-block",
    [theme.breakpoints.down("md")]: {
      width: "50%",
      height: "50%",
      marginLeft: "25%"
    }
  }
}));

const About = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Card className={classes.cardRoot}>
        <CardContent className={classes.CardContent}>
          <img src={logo} className={classes.logo} alt="logo" />
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.heading}
          >
            About
          </Typography>

          <Typography variant="body2" color="textSecondary" component="p">
            Store Description Here
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default About;
